import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

const DEFAULT_STEP = 1;

const SettingsStepContext = createContext(null);

export const SettingsStepProvider = ({ children }) => {
  const [step, setStep] = useState(DEFAULT_STEP);

  const resetStep = useCallback(() => {
    setStep(DEFAULT_STEP);
  }, []);

  const value = { step, setStep, resetStep };

  return (
    <SettingsStepContext.Provider value={value}>
      {children}
    </SettingsStepContext.Provider>
  );
};

export const useSettingsStepContext = () => {
  const ctx = useContext(SettingsStepContext);
  if (!ctx) {
    throw new Error(
      'useSettingsStepContext must be used within SettingsStepProvider',
    );
  }
  return ctx;
};
